// Compact environment chip shown on every non-production lane, inline next
// to the brand in the header so nobody mistakes the test system for the
// real one. Hidden entirely in production. Label only — no description.

import { useAppEnvironment } from '../config/ConfigContext.js';

export function EnvironmentBadge(): JSX.Element | null {
  const environment = useAppEnvironment();
  if (!environment || environment === 'production') return null;

  const label = environment === 'stage' ? 'STAGE' : 'DEVELOPMENT';

  return (
    <span className="env-badge" title="This is not the live system.">
      <span aria-hidden="true">⚠</span>
      {label}
    </span>
  );
}
